import React, { useState, useEffect } from "react";
import "../styles/WebDev.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ContactPage from "./ContactPage";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { motion } from "framer-motion";

const WebDev = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [gmail, setGmail] = useState("");
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");
  const [visibleRows, setVisibleRows] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const navigate = useNavigate();
  const handleClicked = () => {
    navigate("/contact");
  };

  const handleToggle = (id) => {
    setVisibleRows((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const features = [
    {
      img: "/images/image 26.webp",
      bgImg: "/images/bg1.webp",
      title: "Website Development",
      description:
        "We deliver high quality, customized web solutions and seamless user experiences to help businesses grow in a digital world."
    },
    {
      img: "/images/image 27.webp",
      bgImg: "/images/bg2.webp",
      title: "ECommerce Website",
      description:
        "Our Ecommerce Website Development services create user-friendly, secure, and scalable online stores. We integrate seamless payment systems, responsive designs, and optimized performance to enhance user experience and boost sales growth."
    },
    {
      img: "/images/image 28.webp",
      bgImg: "/images/bg3.webp",
      title: "Website Redesign",
      description:
        "Our Website Redesign services renovate your site with modern, responsive designs, improved user experience, and enhanced functionality. We focus on optimizing performance, aesthetics, and conversion to drive better results for your business."
    },
    {
      img: "/images/image 29.webp",
      bgImg: "/images/bg4.webp",
      title: "Custom Web design",
      description:
        "Our Custom Web Design services create unique, visually appealing websites to your brand’s needs. We focus on delivering personalized designs, seamless user experiences, and responsive functionality to engage and convert visitors."
    },
    {
      img: "/images/image 30.webp",
      bgImg: "/images/bg5.webp",
      title: "PHP Web development",
      description:
        "Our services offer dynamic, scalable and secure websites. We create customized PHP solutions that optimize performance, enhance functionality and ensure seamless user experiences tailored to your business needs."
    },
    {
      img: "/images/image 31.webp",
      bgImg: "/images/bg6.webp",
      title: "CRM Web Development",
      description:
        "Our services help businesses build customized customer relationship management systems. We create scalable, user-friendly CRM solutions that streamline processes, enhance customer engagement, and improve overall business efficiency."
    }
  ];

  const data = [
    {
      id: 1,
      title: "What’s the difference between web design and web development?",
      content:
        "Web design focuses on the visual layout and user experience, while web development is about building the website’s structure, functionality and code."
    },
    {
      id: 2,
      title: "What technologies are used in website development?",
      content:
        "Common technologies used include HTML, CSS, JavaScript, PHP, Python and frameworks like React, Angular and WordPress for content management."
    },
    {
      id: 3,
      title: "Do I need a custom-built website?",
      content:
        "If your business requires unique functionality, design, or integration, a custom-built website is ideal. For simpler needs, a template-based website might be sufficient."
    },
    {
      id: 4,
      title: "What is website maintenance?",
      content:
        "Website maintenance involves regularly updating software, fixing bugs, improving performance, and ensuring security to keep your site running smoothly and efficiently."
    },
    {
      id: 5,
      title: "Do you offer website hosting?",
      content:
        "Yes, we offer reliable website hosting services that include fast load times, secure servers, and regular backups to ensure your site remains accessible and protected."
    }
  ];

  const features1 = [
    {
      img: "/images/bg1.webp",
      bgImg: "/images/bg1.webp",
      title: "Requirements gathering",
      description:
        "Requirements gathering in web development involves identifying user needs, business goals, and technical constraints to ensure a functional, user-friendly, and scalable website."
    },
    {
      img: "/images/bg2.webp",
      bgImg: "/images/bg2.webp",
      title: "Research",
      description:
        "Research in web development involves analyzing user behavior, industry trends, and technology to create efficient, user-friendly, and innovative digital experiences."
    },
    {
      img: "/images/bg3.webp",
      bgImg: "/images/bg3.webp",
      title: "Crafting website design",
      description:
        "Crafting website design involves blending aesthetics, usability, and functionality to create visually appealing, responsive, and user-friendly digital experiences that engage and convert visitors."
    },
    {
      img: "/images/bg4.webp",
      bgImg: "/images/bg4.webp",
      title: "Coding based on design",
      description:
        "Coding based on design in web development involves translating visual concepts into functional, responsive, and interactive websites using HTML, CSS, JavaScript, and frameworks."
    },
    {
      img: "/images/bg4.webp",
      bgImg: "/images/bg4.webp",
      title: "Testing the end product",
      description:
        "Testing the end product in web development ensures functionality, performance, security, and user experience by identifying and fixing bugs before deployment."
    },
    {
      img: "/images/bg4.webp",
      bgImg: "/images/bg4.webp",
      title: "Launching a website",
      description:
        "Launching a website involves deploying code, configuring servers, optimizing performance, ensuring security, and promoting it for users to access seamlessly online."
    },
    {
      img: "/images/bg4.webp",
      bgImg: "/images/bg4.webp",
      title: "Maintenance and support",
      description:
        "Maintenance and support in web development involves bug fixing, security updates, performance optimization, user support, backups and server management."
    }
  ];

  const handleSubmit = async () => {
    if (!firstName || !lastName || !gmail) {
      toast.error("Please fill all the required fields!");
      return;
    }

    const payload = {
      firstName: firstName,
      lastName: lastName,
      email: gmail,
      phonenumber: phone,
      message: message,
      type: "contact"
    };

    console.log(payload);

    try {
      const response = await axios.post(
        "https://tnreaders.in/web/contact",
        payload
      );
      console.log(response);

      if (response.status === 200) {
        toast.success("Submitted Successfully");
        setFirstName("");
        setLastName("");
        setGmail("");
        setMessage("");
      }
    } catch (error) {
      toast.error("Error submitting form. Please try again!");
      console.error("API Error:", error);
    }
  };

  return (
    <>
      <section className="websection">
        <div className="websection1">
          <motion.h2
            className="websection2"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            Best web development services
          </motion.h2>
          <motion.p
            className="fsp websection3"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8, ease: "easeOut" }}
          >
             Experience the power of a seamless online journey with the
             cutting-edge web development services we provide for your business.
          </motion.p>
          <motion.button
            className="uiuxbutton"
            onClick={handleClicked}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1, duration: 0.5 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Let's talk &#8594;
          </motion.button>
        </div>
      </section>

      <section className="uiiuxx">
        <h2 className="fsh2 m1">SERVICES</h2>
        <h2 className="fsh3 m0 mb2">Website Development services we offer</h2>
        <div className="serviceoffer">
          <div className="serviceoffer1">
            <div className="serviceoffer3">
              <div className="serviceoffer2">
                <img src="/images/image 76.webp" alt="" />
              </div>
              <div>
                <h2 className="serviceoffer4">Custom web development</h2>
              </div>
            </div>
            <div className="serviceoffer3" style={{ marginRight: "200px" }}>
              <div className="serviceoffer2">
                <img src="/images/image 77.webp" alt="" />
              </div>
              <div>
                <h2 className="serviceoffer4">Web portal development</h2>
              </div>
            </div>
          </div>
          <div>
            <img className="girlhold" src="/images/boyhold.webp" alt="" />
          </div>
          <div className="serviceoffer1">
            <div className="serviceoffer3">
              <div className="serviceoffer2">
                <img src="/images/image 79.webp" alt="" />
              </div>
              <div>
                <h2 className="serviceoffer4">E-commerce web development</h2>
              </div>
            </div>
            <div className="serviceoffer3" style={{ marginLeft: "200px" }}>
              <div className="serviceoffer2">
                <img src="/images/image 80.webp" alt="" />
              </div>
              <div>
                <h2 className="serviceoffer4">Maintenance & support</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="sectioon2">
        <div className="sec2main">
          <div className="sec2sub1 m">
            <h2 className="webserviceh4 fsh2">Who we are</h2>
            <p className="webservicep fsp col-md-10">
              We are a Web Development Company dedicated to delivering
              high-quality, customized web solutions. Our expert combines
              innovation and design to create impactful websites that drive
              business success and growth.
            </p>
          </div>
          <div className="sec2sub2 justify-content-evenly align-items-center mb2">
            <div className="sec2child1">
              <h3 className="different fsh3">
                MPeoples Web design & Development
              </h3>
              <p className="differentp fsp">
                In MPeoples we offer a development through PHP, Angular, Node
                and React JS As a website development company we also focus on
                quality of designs and on-page optimization. Our front-end
                development provides 100% responsive and mobile compatible
                responsive in all other devices.
              </p>
              <button className="button">
                <a
                  style={{
                    textDecoration: "none",
                    color: "white",
                    fontWeight: "200",
                    fontSize: "18px"
                  }}
                  href="/contact"
                >
                  {" "}
                  Contact us <span className="arrow">&#8594;</span>
                </a>
              </button>
            </div>
            <div className="sec2child2">
              <div className="grandchild">
                <h1 className="grandchildp">GET IN TOUCH WITH US</h1>
                <div className="grandchildint">
                  <div>
                    <input
                      type="text"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      placeholder="Enter First Name"
                      className="sect2input2"
                      required
                    />
                  </div>
                </div>

                <div className="grandchildint1">
                  <div>
                    <input
                      type="text"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      placeholder="Enter Last Name"
                      className="sect2input2"
                      required
                    />
                  </div>
                </div>

                <div className="grandchildint2">
                  <div>
                    <input
                      className="sect2input2"
                      type="tel"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      placeholder="Enter Mobile Number"
                      required
                    />
                  </div>
                </div>

                <div className="grandchildint2">
                  <div>
                    <input
                      className="sect2input2"
                      type="email"
                      value={gmail}
                      onChange={(e) => setGmail(e.target.value)}
                      placeholder="Enter Gmail"
                      required
                    />
                  </div>
                </div>
                <div className="grandchildint3">
                  <div>
                    <textarea
                      className="sect2input2"
                      type="Message"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Message"
                      required
                    />
                  </div>
                </div>
                <button className="buttun" onClick={handleSubmit}>
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="mainsec2 d-flex flex-column justify-content-center align-items-center m">
        <div className="text-start text-md-center d-flex flex-column align-items-left align-items-md-center justify-content-center mb2">
          <h2 className="fsh2 m0 mb2">Process</h2>
          <p className="fsh3 m0 mb2">How do we process Web development</p>
        </div>

        <div className="row g-4 w-100">
          {features1.map((feature, index) => (
            <div key={index} className="col-md-10 col-lg-6">
              <div
                className="card shadow-sm p-3 h-100 d-flex flex-column justify-content-center align-items-center section2box"
                style={{ border: "2px solid #137eb1" }}
              >
                <div
                  className="d-flex justify-content-between justify-content-md-center align-items-center w-100"
                  onClick={() => isMobile && toggleAccordion(index)}
                  style={{ cursor: isMobile ? "pointer" : "default" }}
                >
                  <div className="d-flex flex-md-column align-items-center justify-content-center gap-3">
                    <div className="section2img">
                      <img
                        src={feature.img}
                        alt={feature.title}
                        className="card-img-top img-fluid"
                      />
                    </div>
                    <h5 className="fsh4">{feature.title}</h5>
                  </div>
                  <div>
                    {isMobile && (
                      <span className="fs-4">
                        {activeIndex === index ? "−" : "+"}
                      </span>
                    )}
                  </div>
                </div>

                <div
                  className={`card-body ${isMobile ? "accordion-content" : ""}`}
                  style={{
                    display: isMobile
                      ? activeIndex === index
                        ? "block"
                        : "none"
                      : "block",
                    transition: "all 0.3s ease"
                  }}
                >
                  <p className="fsp">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
          <div
            className="col-md-10 col-lg-6 d-flex flex-column justify-content-center 
 align-items-center"
          >
            <div className=" digtrans">
              <h2 className="mb-4" style={{ color: "white" }}>
                Start Your Digital Transformation With Us
              </h2>
              <button
                onClick={handleClicked}
                className="btn px-4 py-2"
                style={{
                  backgroundColor: "white",
                  color: "#137eb1"
                }}
              >
                Connect With Us
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="m d-flex flex-column justify-content-center align-items-center">
        <div className="builder">
          <div className="builderimage">
            <img
              src={"/images/guy.webp"}
              alt=""
              style={{
                height: "236px",
                marginBottom: "32px",
                textShadow: "2px 2px 4px #000000"
              }}
            />
          </div>
          <div className="buiderimage1">
            <h2 className="buiderimage1h2 fsh3" style={{ color: "white" }}>
              Better discussions, better decisions
            </h2>
            <p className="fsp" style={{ color: "#FBBC04" }}>
              We are for everyone - Startups, SMBs, Enterprises. Connect with us
              for a conversation.
            </p>
            <button className="button" style={{ textAlign: "right" }}>
              <span className="text2">
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="/contact"
                >
                  Speak to us &rarr;
                </a>
              </span>
              <div className="circle2"></div>
            </button>
          </div>
        </div>
      </section>

      <section className="m">
        <div className="">
          <h2 className="fsh2 m0 mb2 text-start text-md-center">
            Your Software Product, Our Responsibility
          </h2>
          <div className="row align-items-center g-1">
            <div className="col-md-4 gy-4">
              <div className="feature-box">
                <img
                  className="feature-img mb2"
                  src="/images/image 38.webp"
                  alt="High Automation"
                />
                <h3 className="fsh4 feature-title">High Automation</h3>
                <p className="fsp text-md-center text-start">
                  Our services streamline your business processes, enhance
                  efficiency, and reduce manual effort. We implement intelligent
                  automation solutions to optimize workflows, improve
                  productivity, and drive faster, smarter results.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-box">
                <img
                  className="feature-img mb2"
                  src="/images/image 39.webp"
                  alt="Smart Prediction"
                />
                <h3 className="fsh4 feature-title">Smart Prediction</h3>
                <p className="fsp text-md-center text-start">
                  Our services leverage advanced algorithms and machine learning
                  to forecast trends, behaviors, and outcomes. We create web
                  solutions that provide accurate insights, empowering
                  businesses to make data-driven decisions.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-box">
                <img
                  className="feature-img mb2"
                  src="/images/image 40.webp"
                  alt="Quality Coding"
                />
                <h3 className="fsh4 feature-title">Quality Coding</h3>
                <p className="fsp text-md-center text-start">
                  Our services ensure clean, efficient, and scalable code. We
                  follow best practices to deliver robust, high-performance
                  solutions that meet your business needs while ensuring
                  maintainability and security.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactPage />

      {/*SECTION 6*/}
      {/* <section className="wefocussection m">
        <h2 className="wefocush4 fsh2 m0 mb2">We Focus on</h2>
        <div className="gridsection">
          <div className="gridsection1">
            <h3 className="fsh4">Dynamic & Mobile Ready Website</h3>
            <p className="fsp">
              We provide seamless user experiences across all devices. We create
              responsive, interactive sites that adapt to any screen size,
              ensuring high performance, functionality, and user engagement.
            </p>
          </div>
          <div className="gridsection1">
            <h3 className="fsh4">Convenient Navigation</h3>
            <p className="fsp">
              Our web development ensures users can easily find what they need.
              We design intuitive, user-friendly menus and layouts that enhance
              the browsing experience and drive higher engagement.
            </p>
          </div>
          <div className="gridsection1">
            <h3 className="fsh4">Performance-Ready Websites</h3>
            <p className="fsp">
              We are optimized for speed, reliability, and scalability. We focus
              on fast loading times, smooth navigation, and high efficiency to
              deliver a seamless experience and enhance user satisfaction.
            </p>
          </div>
          <div className="gridsection1">
            <h3 className="fsh4">Analytics and the aftermath</h3>
            <p className="fsp">
              We provide valuable insights into your website's performance. We
              analyze user behavior, conversion rates and traffic trends,
              helping you optimize strategies and improve future marketing
              efforts for better results.
            </p>
          </div>
          <div className="gridsection1">
            <h3 className="fsh4">Web Browsers Compatibility</h3>
            <p className="fsp">
              We ensure your website functions flawlessly across all major
              browsers, including Chrome, Firefox, Safari and Edge. We test and
              optimize designs for consistent performance and user experience
              everywhere.
            </p>
          </div>
          <div className="gridsection1">
            <h3 className="fsh4">Sitemap and Architecture</h3>
            <p className="fsp">
              We ensure a well-structured website. We design clear navigation
              and logical content organization, making it easy for users and
              search engines to access and understand your site.
            </p>
          </div>
        </div>
      </section> */}

      {/*SECTION 7*/}
      {/* <section className="wefocush4webs m">
        <h2 className="wefocush4 fsh2 mb2">Our Approach web development</h2>
        <div className="mainalign">
          <div className="parentalign">
            <img src="/images/Rect1.webp" alt="" className="childalign" />
            <h3 className="fsh4">Website Registration</h3>
            <p className="childp fsp">
              We design seamless registration forms with secure authentication
              processes, ensuring a smooth user experience while protecting
              sensitive data.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/Rect2.webp" alt="" className="childalign" />
            <h3 className="fsh4">Website Planning</h3>
            <p className="childp fsp">
              Website Planning in Development involves defining goals, target
              audience and functionality. We create detailed blueprints,
              including design, structure and content strategy, ensuring a clear
              direction for a successful website launch.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/Rect3.webp" alt="" className="childalign" />
            <h3 className="fsh4">UX Design</h3>
            <p className="childp fsp">
              The next step is creating a user experience. It is a crucial step
              as it makes your product, service, or website stand out from your
              competitors.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/Rect4.webp" alt="" className="childalign" />
            <h3 className="fsh4">UI Design</h3>
            <p className="childp fsp">
              UI and UX and opposite sides of a coin. One cannot exist without
              the other. And with us, your user interface will be the talk of
              the town!
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/Rect5.webp" alt="" className="childalign" />
            <h3 className="fsh4">Website Content</h3>
            <p className="childp fsp">
              We focus on crafting engaging, informative and SEO friendly
              content. We create compelling copy, images and multimedia that
              align with your brand, ensuring a strong online presence and user
              engagement.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/Rect6.webp" alt="" className="childalign" />
            <h3 className="fsh4">Website Design</h3>
            <p className="childp fsp">
              Our web designing experts integrate interactive designs in the
              wireframes to ensure visually pleasing website designs to keep the
              customers engaged. We also make sure that the website is
              responsive in this mobile-friendly era.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/Rect7.webp" alt="" className="childalign" />
            <h3 className="fsh4">Approval</h3>
            <p className="childp fsp">
              We know how important it is for our clients to be on-board with us
              every step of the way. That is why we make sure you are kept in
              the loop always.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/Rect8.webp" alt="" className="childalign" />
            <h3 className="fsh4">Website Development and Testing</h3>
            <p className="childp fsp">
              Website construction involves converting the content and design
              into web code based on conformance with certain guidelines that
              include.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/Rect9.webp" alt="" className="childalign" />
            <h3 className="fsh4">Website Hosting</h3>
            <p className="childp fsp">
              We ensure reliable, secure and fast access to your website. Our
              team manages server configurations, uptime monitoring and
              scalability to support performance and growth seamlessly.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/Rect10.webp" alt="" className="childalign" />
            <h3 className="fsh4">Website Maintenance and Review</h3>
            <p className="childp fsp">
              It involves regular updates, bug fixes and performance checks. Our
              team ensures your site remains secure, functional, and optimized,
              providing ongoing support for seamless operation.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/Rect11.webp" alt="" className="childalign" />
            <h3 className="fsh4">Post development support</h3>
            <p className="childp fsp">
              It ensures ongoing assistance after website launch. Our team
              provides troubleshooting, updates, performance monitoring and
              optimization, ensuring your website remains secure, functional and
              aligned with evolving business needs.
            </p>
          </div>
          <div className="parentaligned">
            <div className="backgound">
              <h3 className="fsh4">
                Start your digital transformation with us
              </h3>
              <button className="buttin">
                <a
                  style={{
                    textDecoration: "none",
                    color: "#137eb1",
                    fontWeight: "400",
                    fontSize: "18px"
                  }}
                  href="/contact"
                >
                  Connect with us
                </a>
              </button>
            </div>
          </div>
        </div>
      </section> */}

      {/*SECTION 8*/}
      {/* <section className="interestingfact m">
        <div className="interestingfacts">
          <div className="interestingfacts1">
            <h3 className="interestingfactsh fsh4">
              Interesting Facts And Figures Of Our Success
            </h3>
          </div>
          <div className="interestingfacts1">
            <img src="/images/image 41.webp" alt="" className="ifimages" />
            <h2 className="fsh3">250+</h2>
            <p>Projects</p>
          </div>
          <div className="interestingfacts1">
            <img src="/images/image 42.webp" alt="" className="ifimages" />
            <h2 className="fsh3">50+</h2>
            <p>Satisfied Clients</p>
          </div>
          <div className="interestingfacts1">
            <img src="/images/image 43.webp" alt="" className="ifimages" />
            <h2 className="fsh3">6+</h2>
            <p>Industry Experience</p>
          </div>
          <div className="interestingfacts1">
            <img src="/images/image 44.webp" alt="" className="ifimages" />
            <h2 className="fsh3">20+</h2>
            <p>Developement People</p>
          </div>
        </div>
      </section> */}

      {/*SECTION 9*/}
      {/* <section className="hireme m d-flex flex-column ">
        <div className="hiremain d-flex flex-column justify-content-md-center justify-content-start align-items-md-center align-items-start text-start text-md-center m0 mb2">
          <h2 className="wefocush4 fsh2 m0 mb2" style={{ color: "#137eb1" }}>
            Hire Our Professional Website{" "}
            <span style={{ color: "black" }}> Developers</span>
          </h2>
          <p className="hiremainp fsp m0 mb2 col-10">
            If you have a Website problem, hire an expert Website developer to
            fix it! Hire Our Professional Website Developers to bring your
            vision to life. With expertise in custom designs, responsive
            development and seamless functionality, we ensure your website
            delivers exceptional user experiences and business growth.
          </p>
        </div>
        <div className="hire m0 mb2">
          <div className="hire1">
            <img src="/images/image 45.webp" alt="" className="hireimg" />
            <p className="fsh4">Monthly</p>
          </div>
          <div className="hire1">
            <img src="/images/image 46.webp" alt="" className="hireimg" />
            <p className="fsh4">Hourly</p>
          </div>
          <div className="hire1">
            <img src="/images/image 47.webp" alt="" className="hireimg" />
            <p className="fsh4">Maintenance</p>
          </div>
          <div className="hire1">
            <img src="/images/image 48.webp" alt="" className="hireimg" />
            <p className="fsh4">Contract</p>
          </div>
        </div>
        <div className="design p">
          <div style={{ color: "white" }} className="text-md-center text-start">
            <h3 className="fsh4 m0 mb2">
              Looking for{" "}
              <span style={{ color: "#FAAB1E" }}>
                Top-Tier Website Development?
              </span>
               
            </h3>
            <p style={{ color: "white" }} className="desh2 fsp m0 mb3">
              Hire Our Team of Expert Developers and Elevate Your Online
              Presence!
            </p>
          </div>
          <div>
            <button className="hiremebtn">
              <a
                style={{ textDecoration: "none", color: "white" }}
                href="/contact"
              >
                Hire Now!
              </a>
            </button>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default WebDev;
